import React, { Component } from 'react';
import { connect } from 'react-redux';

import AttributeSelect from './AttributeSelect';

import styles from './_styles/EditSectionBlock.module.scss';

const allActionCreators = Object.assign({});

export class EditSectionAttributeBlock extends Component {
	
	render() {
		return <div className={`${styles.EditSectionBlock}`}>
			<div className={styles.body}>
				{this.props.attributes?.map((attr, i) => {

					if(!attr.attributes?.length) {
						return null;
					}

					return <div key={i} className={styles.elementWrapper}>
						<AttributeSelect
							attributeType={attr.type}
							attributeOptions={attr.attributes}
							value={this.props.values[attr.type.key] || ''}
							onChange={this.props.onChange.bind(this)} />
					</div>
				})}
			</div>
		</div>;
	}
}

function mapStateToProps(state) {
	return {

	};
}

export default connect(mapStateToProps, allActionCreators)(EditSectionAttributeBlock);